import React, { useEffect, useState } from 'react'
import { FaChevronRight, FaFilter } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { getData } from '../../../store/utils';

function InventoryComponent() {

    const [dataList, setDataList] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    const onFetchInventoryData = async () => {

        const apiUrl = `inventory/inventoryList?search=&page=1&pageSize=10`
        try {
            const response = await getData(apiUrl);

            console.log(response,"tempdata");
            
            if (response?.statusCode == 200) {
                setDataList(response?.data?.records)
            }
        } catch (error) {

            console.log(error,"error");
            

        }

        


    }

    console.log(dataList,"datalist");
    

    useEffect(() => {
        onFetchInventoryData()
    }, [])
    return (
        <div className='warehouseCardsec'>

            <div className="row mt-3">
                <div className="col-sm-12">
                    <div className="scroll-wrapper" >

                        <ul className="cardlisting">
                            {dataList?.length === 0 ? (
                                <li className="noOrdersMsg">No Orders Found</li>
                            ) : (
                                dataList?.map((item, index) => (

                                    <li
                                        key={index}
                                        className={`baseClass ${item.shipmentStatusId == 41
                                            ? "green"
                                            : item.shipmentStatusId == 48
                                                ? "yellow"
                                                : "grey"
                                            }`}
                                    >
                                        <Link
                                        // to={{
                                        //     pathname: `/WarehouseOrderDetail/${item?.orderId}`,
                                        //     state: { item }, // Pass data to the route
                                        // }}
                                        // onClick={() => onItemClick(item)} // Trigger callback with item data
                                        >
                                            <div>
                                                <div className="d-flex justify-content-between">
                                                    <div><b className="me-1">#{item?.productName}</b></div>
                                                    <div className="text-truncate-shopname">{item?.quantity}</div>
                                                </div>
                                                <div className="mt-1 d-flex justify-content-between align-items-center">
                                                    <div style={{ color: "#999" }}>
                                                        {item?.sellingPrice}
                                                    </div>
                                                    {/* <div className="viewicon">
                                                        <button className="btn btn-primary">
                                                            <FaChevronRight />
                                                        </button>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>


                </div>
            </div>
        </div>

    )
}

export default InventoryComponent